"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _reactJss = _interopRequireDefault(require("react-jss"));

var _clsx = _interopRequireDefault(require("clsx"));

var _constants = require("../constants");

var _utils = _interopRequireDefault(require("../utils/utils"));

var _Icon = _interopRequireDefault(require("../Icon/Icon.js"));

var _Avatar = _interopRequireDefault(require("../Avatar/Avatar.js"));

var _Label = _interopRequireDefault(require("../Label/Label.js"));

var _Chip = _interopRequireDefault(require("./Chip.style"));

var _dec, _class;

let Chip = (_dec = (0, _reactJss.default)(_Chip.default), _dec(_class = class Chip extends _react.PureComponent {
  constructor(props) {
    super(props);
    this.closeClick = this.closeClick.bind(this);
  }

  closeClick(e) {
    e.stopPropagation();
    const {
      closeClick
    } = this.props;
    closeClick();
  }

  render() {
    const {
      id,
      classes,
      className,
      label,
      src,
      icon,
      closeIcon,
      onClick,
      onMouseEnter,
      onMouseLeave,
      type,
      size,
      unspaced,
      unbordered,
      color,
      fontSize,
      fontWeight,
      children,
      borderColor,
      bgColor,
      dataTestId
    } = this.props;
    const chipClasses = (0, _clsx.default)(className, (0, _clsx.default)(classes.chip, {
      unspaced,
      unbordered
    }), classes[type], classes[size], classes[`backgroundColor__${color}`], classes[`borderColor__${unbordered ? color : borderColor}`]);
    const hasSrc = src && src.length;
    return /*#__PURE__*/_react.default.createElement("div", {
      id: id,
      className: chipClasses,
      style: {
        borderColor,
        backgroundColor: bgColor
      },
      onClick: onClick,
      onMouseEnter: onMouseEnter,
      onMouseLeave: onMouseLeave,
      "data-testid": dataTestId
    }, hasSrc && /*#__PURE__*/_react.default.createElement(_Avatar.default, {
      size: "medium",
      src: src,
      className: (0, _clsx.default)(classes.avatar)
    }), icon && !hasSrc && /*#__PURE__*/_react.default.createElement(_Icon.default, {
      type: icon,
      size: "small",
      className: (0, _clsx.default)(classes.icon)
    }), (0, _react.isValidElement)(label) ? label : /*#__PURE__*/_react.default.createElement(_Label.default, {
      duplicatingTooltip: true,
      fontSize: fontSize,
      fontWeight: fontWeight,
      value: label,
      textColor: "inherit",
      className: (0, _clsx.default)(classes.label)
    }), children, closeIcon && /*#__PURE__*/_react.default.createElement(_Icon.default, {
      type: "close",
      size: "micro",
      color: "currentColor",
      className: (0, _clsx.default)(classes.closeIcon),
      onClick: this.closeClick
    }));
  }

}) || _class);
Chip.defaultProps = {
  closeIcon: true,
  closeClick: () => {},
  onMouseEnter: () => {},
  onMouseLeave: () => {},
  size: 'medium',
  fontSize: 'medium',
  fontWeight: 'semibold',
  type: 'rounded',
  children: null
};
Chip.COLOR = _utils.default.pick(_constants.COLOR, ['accent']);
var _default = Chip;
exports.default = _default;